import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { DiscountsRouteNames, DiscountsRoutePathNames } from '../../enums';
import { beforeEnter } from '../guards/index';

const List = () => import('./List.vue');

export const listRoute: RouteRecordRaw = {
  path: buildChildURL(DiscountsRoutePathNames.LIST),
  name: DiscountsRouteNames.DISCOUNTS_LIST,
  component: List,
  beforeEnter: beforeEnter,
};
